import { Textarea } from '@checkatrade/web-ui';

type Props = {
  textarea?: boolean;
  name: string;
  value: string;
  required: boolean;
  onChange: (value: string) => void;
  type?: 'text' | 'number';
  min?: number | null;
  max?: number | null;
};

const TextInput = ({
  textarea,
  name,
  value,
  required,
  onChange,
  type = 'text',
  min = 0,
  max = 100,
}: Props) => {
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    event.preventDefault();
    const { value: newValue } = event.target;
    onChange(type === 'text' ? newValue.slice(0, max || 100) : newValue);
  };

  const error =
    value.length > 0 && value.replace(/\s+$/g, '').trim().length < (min || 0);

  const textareaError = error
    ? `At least ${min} characters required`
    : undefined;

  return (
    <>
      {textarea ? (
        <Textarea
          value={value}
          placeholder="Add information"
          required={required}
          onChange={handleChange}
          minLength={min ?? undefined}
          maxLength={max ?? undefined}
          label={name}
          name={name}
          error={textareaError}
          className={{ label: 'sr-only' }}
        />
      ) : (
        <>
          <input
            type={type}
            name={name}
            value={value}
            aria-label={name}
            placeholder="Add information"
            className={`mb-2 w-full rounded border  p-3 ${error ? 'border-caution-60' : ''}`}
            onChange={handleChange}
          />
          {type === 'text' && min && min > 0 && (
            <div
              className={`flex justify-between text-xs ${error ? 'text-caution-70' : 'text-neutral-600'}`}
            >
              {error ? (
                <p>{`At least ${min} characters required`}</p>
              ) : (
                <>
                  <p>{`Min characters: ${min}`}</p>
                  <p>
                    {value.length}/{max}
                  </p>
                </>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TextInput;
